import { Warning } from "@phosphor-icons/react";
import { Badge } from "components/ui/badge";
import { VAT_WARNING_TEXT } from "shared/utils/invoiceVat";

interface Props {
  /** Niets tonen wanneer er geen waarschuwing is. */
  warning?: string | null;
  /** Alleen het icoon, voor smalle tabelkolommen. */
  iconOnly?: boolean;
  className?: string;
}

/**
 * Markeert een factuur waarvan de btw niet uit Odoo te halen is: de Peppol-import
 * kon de btw-code niet koppelen, dus wat als "excl btw" geboekt staat is in
 * werkelijkheid het brutobedrag van de factuur.
 *
 * Kleurgebruik: lichte brick-achtergrond met donkere neutrale tekst. De brick-kleur
 * zelf (#EA8162) is te licht voor tekst op wit — die wordt alleen voor het icoon en
 * de rand gebruikt, zodat de tekst leesbaar blijft.
 */
export const VatWarningBadge = ({
  warning,
  iconOnly = false,
  className = "",
}: Props) => {
  if (!warning) return null;

  if (iconOnly) {
    return (
      <span title={warning} aria-label={warning} className={className}>
        <Warning size={16} className="text-brick-primary" weight="fill" />
      </span>
    );
  }

  return (
    <Badge
      variant="outline"
      title={warning}
      className={`bg-brick-secondary-fine border-brick-primary text-neutral-primary gap-1 font-medium whitespace-nowrap ${className}`}
    >
      <Warning size={14} className="text-brick-primary" weight="fill" />
      {warning}
    </Badge>
  );
};

VatWarningBadge.defaultText = VAT_WARNING_TEXT;
